import ConfigProvider from './config-provider';
import { config } from '@ss/mtd-vue/es/utils/config';

/* istanbul ignore next */
ConfigProvider.install = function (Vue) {
  Vue.component(ConfigProvider.name, ConfigProvider);
};

ConfigProvider.config = config;

export default ConfigProvider;